export const ADVANCED_COLOR_OPTIONS = {
  primaryBlue: '#002d72',
  black: '#000000',
  lightBlue: '#0064fe',
  green: '#548d25',
  cyanBlue: '#597ba2',
  orange: '#ff4c31',
  lightGray: '#686b75',
  cyanBlueDark: '#3a6774',
  magenta: '#7441b5',
  red: '#d10b0b',
  maroon: '#a4002b',
  darkBrown: '#6e4f35',
  darkGray: '#25200e',
  darkBlue: '#1f2043',
  primaryYellow: '#ffe500',
  white: '#ffffff',
  whiteWithPromo: 'whiteWithPromo',
};

export const COLOR_CLASSES = {
  white: 'advanced-carousel-white',
  primaryBlue: 'advanced-carousel-primaryBlue',
  primaryYellow: 'advanced-carousel-primaryYellow',
  green: 'advanced-carousel-green',
  black: 'advanced-carousel-black',
  whiteWithPromo: 'advanced-carousel-promo-white',
};

export const CAROUSEL_COLORS = {
  white: 'white',
  primaryBlue: 'primaryBlue',
  primaryYellow: 'primaryYellow',
  green: 'green',
  black: 'black',
  whiteWithPromo: 'whiteWithPromo',
};

export type CarouselColor = typeof CAROUSEL_COLORS[keyof typeof CAROUSEL_COLORS];

export const ADVANCED_TYPE_OPTIONS = {
  titleWithCarousel: 'titleWithCarousel',
  textboxWithCarousel: 'textboxWithCarousel',
  bannerWithCarousel: 'bannerWithCarousel',
};

export type CarouselType = typeof ADVANCED_TYPE_OPTIONS[keyof typeof ADVANCED_TYPE_OPTIONS];

export const RECOMMENDATION_TYPE_OPTIONS = {
  TOP_SELLER: 'Top sellers',
  BEST_DEALS: 'Best deals',
  NEW_PRODUCTS: 'New products',
};

export type RecommendationsType = typeof RECOMMENDATION_TYPE_OPTIONS[keyof typeof RECOMMENDATION_TYPE_OPTIONS];

export const TRACKING_NAMES = {
  BEST_SELLING: 'best selling products',
  LATEST_DEALS: 'latest deals',
  NEW_PRODUCTS: 'new products',
};

export type TrackingNameType = typeof TRACKING_NAMES[keyof typeof TRACKING_NAMES];
